import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getIssueList, clearIssueList } from "../../actions/common.action";
import {
  createIssueAction,
  isIssueDuplicatedAction
} from "../../actions/issues.action";
import AddIssue from "../createProjectAddIssueForm/AddIssue";
import { Button, Image, Modal } from "react-bootstrap";
import {
  getLocalstorage,
  GROUP_KEYS,
  isValidArray,
  PromisesHelper,
  ScrollToView
} from "../../helper";
import { get } from "lodash";
import { toast } from "react-toastify";
import { modifyDataOfAddIssue, validateDuplicatedIssue } from "../../helper";
import ProjectDetailWithLoader from "./ProjectDetailWithLoader";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { ERROR_MSG, STATUS } from "../../constant";
import IssueListWitLoader from "../IssueListWithLoader/IssueListingWithLoader";
import Pagination from "../Pagination";
import PermissionHOC from "../PermissionHOC";
import { LoaderPage } from "../../component/Loader";
import { Redirect } from "react-router-dom";
import { PATHS } from "../../constant";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import {
  declareMonthlyIssueAction,
  getProjectDetails
} from "../../actions/projectDetail.action";
import { fetchAllProjectStatus } from "../../actions/mis.action";
import { successToastStyle, errorToastStyle } from "../../customToast";
import RadioUncheck from "../../assets/radio-uncheck.svg";
import CheckRed from "../../assets/check-red.svg";
import CheckBlue from "../../assets/check-blue.svg";
import EditIssue from "../createProjectAddIssueForm/EditIssue";

const defaultListParams = {
  limit: 10,
  offset: 0,
  projectGroupBy: true
};

class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLanguageError: true,
      error: {},
      issueListApiStatus: STATUS.LOADING,
      issueListParams: { ...defaultListParams },
      isProjectAwardedByStateCategory: false,
      issueSaved: false,
      _createdBy: null,
      initialRequiredFields: [
        "groupCategory",
        "issueCategoryId",
        "issueSubCategoryId",
        "issueDescription",
        "recipientGroupId",
        "title",
        "selectedStateId",
        "selectedMinistryId",
        "issueSubCategoryId",
        "responsibleAuthority"
      ],
      pendingIssue: false,
      noPendingIssue: false,
      pendingIssueRaised: false,
      pendingIssueNotRaised: false,
      showAlertMonthly: false,
      showIssue: false,
      showIssueNext: false,
      page: 1,
      totalPages: 2,
      underMaintenance: false,
      showModal: false,
      issueCOList: [],
      backButtonPress: false,
      ministryList: [],
      STATE: [],
      districtList: [],
      subCategoryList: [],
      milestoneLists: [],
      milestoneTables: [],
      addIssueSubmitModal: false,
      CENTRAL: [],
      DISTRICT: [],
      STATE_DEPARTMENT: [],
      CENTRAL_DEPARTMENT: [],
      OTHER: [],
      INDUSTRIAL: [],
      otherOption: false,
      isProposalValidated: false
    };
    this.myDivToFocus = React.createRef();
    this.issueListContainer = React.createRef();
  }

  componentDidMount() {
    if (this.myDivToFocus && this.myDivToFocus.current) {
      this.myDivToFocus.current.scrollTo(0, 0);
    }
    const { location, getProjectDetails, projectData } = this.props;
    const { projectId } = queryString.parse(location.search);
    getProjectDetails(undefined, { id: +projectId }).then(resp => {
      this.setGroupCategory(resp.data);
      resp && resp.data && this.getIssueListData();
    });
  }
  setGroupCategory(projectData) {
    if (projectData) {
      this.setState({
        isProjectAwardedByStateCategory:
          projectData && projectData.sponsoredByCategory === GROUP_KEYS.STATE
      });
    }
  }
  componentWillReceiveProps(nextProps, nextContext) {
    let { projectData } = nextProps;
    let data = get(projectData, "data", null);
    const createdBy =
      data && data.projectPPList && data.projectPPList.length
        ? data.projectPPList[0]
        : null;
    this.setState({
      _createdBy: createdBy
    });
    let _showIssue =
      get(projectData, "data.status") == "VERIFIED" &&
      get(projectData, "data.projectCompletionDTO.status") != "COMMISSIONED"
        ? true
        : false;

    this.setState({
      showIssue:
        _showIssue &&
        get(projectData, "data.showDeclarationModal") &&
        get(projectData, "data.projectPPList[0].userID") ==
          getLocalstorage("user").userID &&
        get(projectData, "data.sponsoredByCategory") == "CENTRAL"
    });
  }

  handleOnClick = event => {
    if (this.myDivToFocus.current) {
      this.myDivToFocus.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  };

  initialApiCall = () => {
    const { getProjectDetails, location, fetchAllProjectStatus } = this.props;
    const { projectId } = queryString.parse(location.search);
    getProjectDetails(undefined, { id: +projectId }).then(resp => {
      this.getIssueListData(resp);
    });
    fetchAllProjectStatus();
  };

  updateParentState = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  updateParentStateError = (key, value) => {
    this.setState(prevState => {
      return {
        error: {
          ...prevState.error,
          [key]: value
        }
      };
    });
  };

  onSubmit = async () => {
    this.setState({ isApiLoading: true });
    //console.log("success")
    const {
      createIssueDispatch,
      projectData,
      declareMonthlyIssueDispatch
    } = this.props;
    const id = get(projectData, "data.id");
    let isProjectAwardedByState =
      get(projectData, "data.sponsoredByCategory") === GROUP_KEYS.STATE;
    const obj = {
      pendingIssues: true,
      declarationStatus: "NOT_RAISED"
    };
    const response = await declareMonthlyIssueDispatch(
      undefined,
      obj,
      get(projectData, "data.id", null)
    );
    if (response) {
      const { message, status } = response.data.data;
      !status &&
        // toast.success(
        //   <p className="toast-text-alignment">{message}</p>,
        //   successToastStyle
        // )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
    }
    try {
      const modifyData = modifyDataOfAddIssue(
        this.state,
        isProjectAwardedByState
      );
      const response = await createIssueDispatch(undefined, {
        issueCOList: modifyData,
        projectId: id
      });
      if (response) {
        const { message, status } = response;
        (status &&
          toast.success(
            <p className="toast-text-alignment">
              Declaration and Issue Submitted Successfully.
            </p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        this.setState(
          prevState => ({
            //issueSubmitted: STATUS.SUCCESS,
            isApiLoading: false,
            showIssue: false,
            resetForm: true,
            issueCOList: [],
            error: {
              ...prevState.error,
              issueCOListError: null,
              issuesError: []
            }
          }),
          () => {
            this.setState({
              isApiLoading: false,
              resetForm: false,
              issueSaved: true,
              addIssueSubmitModal: false,
              showModal: false,
              showIssue: false
            });
          }
        );
        //this.openConfirmationAlert();
        ScrollToView(this.issueListElement);
        this.updateIssueList();
        this.initialApiCall();
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onSubmitAddIssueForm = async () => {
    //console.log("success")
    const { createIssueDispatch, projectData } = this.props;
    const id = get(projectData, "data.id");
    let isProjectAwardedByState =
      get(projectData, "data.sponsoredByCategory") === GROUP_KEYS.STATE;
    try {
      this.setState({ issueSubmitted: STATUS.LOADING });
      const modifyData = modifyDataOfAddIssue(
        this.state,
        isProjectAwardedByState
      );
      const response = await createIssueDispatch(undefined, {
        issueCOList: modifyData,
        projectId: id
      });
      if (response) {
        const { message, status } = response;
        (status &&
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        this.setState(
          prevState => ({
            issueSubmitted: STATUS.SUCCESS,
            resetForm: true,
            issueCOList: [],
            showAlert: false,
            error: {
              ...prevState.error,
              issueCOListError: null,
              issuesError: []
            }
          }),
          () => {
            this.setState({
              issueSubmitted: STATUS.ERROR,
              resetForm: false,
              showAlert: false,
              issueSaved: true
            });
          }
        );
        //this.openConfirmationAlert();
        ScrollToView(this.issueListElement);
        this.updateIssueList();
        this.initialApiCall();
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onValidateForm = async () => {
    const { error, initialRequiredFields, showModal } = this.state;
    // console.log(this.state.otherOption)
    // console.log(this.state.backButtonPress)
    //  console.log(this.state.issueCOList.length)
    if (
      this.state.otherOption &&
      !this.state.backButtonPress &&
      this.state.issueCOList.length == 0
    ) {
      const { projectData } = this.props;
      const errorObj = { ...error };
      const mandatoryFields = [];
      let isProjectAwardedByState =
        get(projectData, "data.sponsoredByCategory") === GROUP_KEYS.STATE;
      //console.log("success",errorObj.issueCOListError)
      this.setState({ showLanguageError: false });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
      this.setState({
        error: {
          issueCOListError: [
            {
              error: true,
              required_field: initialRequiredFields
            }
          ],
          issuesError: [
            {
              error: true,
              required_field: initialRequiredFields
            }
          ]
        }
      });
      mandatoryFields.push("issueCOListError");
      let invalidForm = false;
      mandatoryFields.forEach(fieldKey => {
        let value = get(errorObj, fieldKey);

        if (!invalidForm) {
          invalidForm = get(value, "error");
        }

        if (fieldKey === "issueCOListError") {
          let issueList = get(errorObj, "issueCOListError");
          errorObj["issuesError"] = issueList.map(value => {
            if (value.error) {
              invalidForm = true;
            }
            return value;
          });
        }
      });

      if (!invalidForm && errorObj.issueCOListError) {
        this.setState({
          error: errorObj
        });
        const isDuplicatedIssueExist = validateDuplicatedIssue(
          this.state.issueCOList
        );
        if (get(isDuplicatedIssueExist, "error")) {
          toast.error(
            <p className="toast-text-alignment">
              {get(isDuplicatedIssueExist, "message")}
            </p>,
            errorToastStyle
          );
        }
      } else {
        this.setState({
          error: errorObj
        });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
          errorToastStyle
        );
      }
    } else if (this.state.otherOption && this.state.backButtonPress) {
      this.setState({ issueCOList: [{}] });
    } else {
      const { projectData } = this.props;
      const errorObj = { ...error };
      const mandatoryFields = [];
      let isProjectAwardedByState =
        get(projectData, "data.sponsoredByCategory") === GROUP_KEYS.STATE;
      this.setState({ showLanguageError: false });
      if (!isValidArray(errorObj.issueCOListError)) {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
          errorToastStyle
        );
        this.setState({
          error: {
            issueCOListError: [
              {
                error: true,
                required_field: initialRequiredFields
              }
            ],
            issuesError: [
              {
                error: true,
                required_field: initialRequiredFields
              }
            ]
          }
        });
      } else {
        mandatoryFields.push("issueCOListError");
        let invalidForm = false;
        mandatoryFields.forEach(fieldKey => {
          let value = get(errorObj, fieldKey);

          if (!invalidForm) {
            invalidForm = get(value, "error");
          }

          if (fieldKey === "issueCOListError") {
            let issueList = get(errorObj, "issueCOListError");
            errorObj["issuesError"] = issueList.map(value => {
              if (value.error) {
                invalidForm = true;
              }
              return value;
            });
          }
        });

        if (!invalidForm && errorObj.issueCOListError) {
          this.setState({
            error: errorObj
          });
          const isDuplicatedIssueExist = validateDuplicatedIssue(
            this.state.issueCOList
          );
          if (get(isDuplicatedIssueExist, "error")) {
            toast.error(
              <p className="toast-text-alignment">
                {get(isDuplicatedIssueExist, "message")}
              </p>,
              errorToastStyle
            );
          } else {
            const modifyIssue = modifyDataOfAddIssue(
              this.state,
              isProjectAwardedByState
            );
            const promiseArr =
              isValidArray(modifyIssue) &&
              modifyIssue.map(issue => {
                issue.projectId = get(projectData, "data.id");
                return isIssueDuplicatedAction(undefined, issue);
              });
            this.setState({ isApiLoading: true });
            const resp = await PromisesHelper(promiseArr);
            if (isValidArray(resp)) {
              let isFormInvalid = false;
              for (let index = 0; index <= resp.length - 1; index++) {
                if (get(resp[index], "data") && !isFormInvalid) {
                  isFormInvalid = true;
                  break;
                }
              }
              if (isFormInvalid) {
                toast.error(
                  <p className="toast-text-alignment">
                    {ERROR_MSG.DUPLICATED_ISSUES_IN_PROJECT}
                  </p>,
                  errorToastStyle
                );
              } else {
                if (showModal) {
                  this.setState({ addIssueSubmitModal: true });
                } else {
                  this.openConfirmationAlert();
                }
              }
              this.setState({ isApiLoading: false });
            }
          }
        } else {
          this.setState({
            error: errorObj
          });
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
            errorToastStyle
          );
        }
      }
    }
  };
  resetAddIssue = value => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        issueCOListError: value,
        issuesError: value
      }
    }));
  };

  addIssueErrorUpdate = value => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        issueCOListError: value
      }
    }));
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: true
      //showModal: false
    }));
  };
  closeModalonAddIsse = () => {
    this.setState({ showAlert: false });
  };
  updateIssueList = offset => {
    const { location } = this.props;
    const { issueListParams } = this.state;
    const { projectId } = queryString.parse(location.search);
    ScrollToView(this.issueListElement);
    this.getIssueListData({
      ...issueListParams,
      offset: offset || 0,
      projectId: projectId
    });
  };

  onPageChange = param => {
    this.getIssueListData({ offset: get(param, "selected") });
    this.issueListContainer.current.scrollIntoView({
      behavior: "smooth"
    });
  };

  getIssueListData = (params = {}) => {
    try {
      const {
        location: { search },
        projectData
      } = this.props;
      const { projectId } = queryString.parse(search) || {};
      const { issueListParams, isProjectAwardedByStateCategory } = this.state;
      let data = get(projectData, "data", null);
      let isProjectAwardedByState =
        data && data.sponsoredByCategory === GROUP_KEYS.STATE;
      if (isProjectAwardedByStateCategory) {
        isProjectAwardedByState = isProjectAwardedByStateCategory;
      }
      if (projectId) {
        this.setState(
          {
            issueListApiStatus: STATUS.LOADING,
            issueListDTO: null
          },
          async () => {
            const response = await getIssueList(undefined, {
              ...issueListParams,
              ...params,
              projectId,
              projectDetail: true,
              groupCategory: isProjectAwardedByState
                ? GROUP_KEYS.STATE
                : GROUP_KEYS.CENTRAL
            });
            if (response) {
              const { status, message, data } = response;
              if (status) {
                this.setState({
                  issueListDTO: data,
                  issueListApiStatus: STATUS.SUCCESS,
                  issueListParams: { ...issueListParams, ...params }
                });
              } else {
                this.setState({
                  issueListApiStatus: STATUS.ERROR
                });
              }
            }
          }
        );
        this.myDivToFocus.current.scrollTo(0, 0);
      } else {
        return <Redirect to={PATHS.PROJECT_LIST} />;
      }
    } catch (e) {
      console.log("Error while fetching error", e);
    }
  };
  // onMouseclick = () => {
  //   window.addEventListener("keyup", event => {
  //     this.setState({
  //       // showLanguageError: true
  //     });
  //   });
  // };

  onRemoveFile = async () => {
    const { initialRequiredFields } = this.state;

    this.setState({
      error: {
        issueCOListError: [
          {
            error: false,
            required_field: initialRequiredFields
          }
        ],
        issuesError: [
          {
            error: false,
            required_field: initialRequiredFields
          }
        ]
      }
    });
  };

  handleCheckboxChange = e => {
    switch (e) {
      case "noPendingIssue":
        this.setState({ noPendingIssue: true });
        this.setState({ pendingIssue: false });
        this.setState({ pendingIssueRaised: false });
        this.setState({ pendingIssueNotRaised: false });
        break;
      case "pendingIssue":
        this.setState({ pendingIssue: true });
        this.setState({ noPendingIssue: false });
        break;
      case "pendingIssueRaised":
        this.setState({ pendingIssueRaised: true });
        this.setState({ pendingIssueNotRaised: false });
        break;
      case "pendingIssueNotRaised":
        this.setState({ pendingIssueNotRaised: true });
        this.setState({ pendingIssueRaised: false });
        break;
      default:
    }
  };

  openConfirmationAlertMonthly = () => {
    this.setState(prevState => ({
      showAlertMonthly: !prevState.showAlertMonthly,
      showIssue: !prevState.showIssue,
      otherOption: true,
      backButtonPress: false
      //showModal: !prevState.showModal
    }));
    //console.log(this.state.otherOption)
  };

  onSubmitMonthlyIssue = async () => {
    const { declareMonthlyIssueDispatch, projectData } = this.props;
    if (this.state.noPendingIssue) {
      this.setState({ showAlertMonthly: false, showIssue: false });

      const obj = {
        pendingIssues: false,
        declarationStatus: "NO_ISSUES"
      };
      const response = await declareMonthlyIssueDispatch(
        undefined,
        obj,
        get(projectData, "data.id", null)
      );
      if (response) {
        const { message, status } = response.data.data;
        (status &&
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      }
    } else if (this.state.pendingIssueRaised) {
      this.setState({ showAlertMonthly: false, showIssue: false });
      const obj = {
        pendingIssues: true,
        declarationStatus: "ISSUES_RAISED"
      };
      const response = await declareMonthlyIssueDispatch(
        undefined,
        obj,
        get(projectData, "data.id", null)
      );
      if (response) {
        const { message, status } = response.data.data;
        (status &&
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      }
    } else if (this.state.pendingIssueNotRaised) {
      this.setState({
        showAlertMonthly: false,
        showIssue: false,
        showIssueNext: true
      });
    }
  };

  proceedToAddIssue = () => {
    // console.log(this.state.backButtonPress)
    // console.log(this.state.otherOption)
    // console.log(this.state.issueCOList)
    if (!this.state.backButtonPress && !this.state.otherOption) {
      this.setState({
        showIssueNext: false,
        showIssue: false,
        showModal: true
        //otherOption:false
      });
    } else if (this.state.backButtonPress && !this.state.otherOption) {
      this.setState({
        showIssueNext: false,
        showIssue: false,
        showModal: true,
        otherOption: false
      });
    } else if (this.state.backButtonPress && this.state.otherOption) {
      this.setState({
        showIssueNext: false,
        showIssue: false,
        showModal: true,
        otherOption: false
      });
    } else if (!this.state.backButtonPress && this.state.otherOption) {
      this.setState({
        showIssueNext: false,
        showIssue: false,
        showModal: true,
        otherOption: true,
        issueCOList: []
      });
    } else {
      this.setState({
        showIssueNext: false,
        showIssue: false,
        showModal: true
      });
    }
  };

  nextPage = () => {
    this.setState(prevState => ({ page: prevState.page + 1 }));
  };
  prevPage = () => {
    this.setState(prevState => ({ page: prevState.page - 1 }));
  };

  onShow = () => {
    localStorage.setItem("DisplayButton", "0");
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }));
  };
  handleClose = () => {
    this.setState(prevState => ({
      addIssueSubmitModal: !prevState.addIssueSubmitModal,
      showModal: true
    }));
  };

  prevPageforModel = (
    data,
    backButtonPress,
    ministryList,
    STATE,
    districtList,
    subCategoryList,
    milestoneLists,
    milestoneTables,
    CENTRAL,
    DISTRICT,
    STATE_DEPARTMENT,
    CENTRAL_DEPARTMENT,
    OTHER,
    INDUSTRIAL
  ) => {
    //console.log("from prevPage 646", data,ministryList);
    this.setState({
      page: 2,
      showModal: false,
      showIssue: true,
      showAlert: false,
      issueCOList: data,
      backButtonPress: backButtonPress,
      ministryList: ministryList,
      STATE: STATE,
      districtList: districtList,
      subCategoryList: subCategoryList,
      milestoneLists: milestoneLists,
      milestoneTables: milestoneTables,
      CENTRAL: CENTRAL,
      DISTRICT: DISTRICT,
      STATE_DEPARTMENT: STATE_DEPARTMENT,
      CENTRAL_DEPARTMENT: CENTRAL_DEPARTMENT,
      OTHER: OTHER,
      INDUSTRIAL: INDUSTRIAL
      // pendingIssueNotRaised: true
    });
  };

  handleProposalChange = proposal => {
    this.setState({ isProposalValidated: proposal });
  };

  render() {
    const { projectData, projectDetailsStatus, permission } = this.props;
    const {
      error,
      initialRequiredFields,
      resetForm,
      showAlert,
      issueSubmitted,
      isApiLoading,
      issueListDTO,
      issueListApiStatus,
      issueListParams: { offset },
      issueSaved,
      _createdBy,
      showIssue,
      noPendingIssue,
      pendingIssue,
      pendingIssueRaised,
      pendingIssueNotRaised,
      showAlertMonthly,
      page,
      addIssueSubmitModal,
      CENTRAL,
      DISTRICT,
      STATE_DEPARTMENT,
      CENTRAL_DEPARTMENT,
      OTHER,
      INDUSTRIAL,
      issueCOList,
      otherOption,
      isProposalValidated
    } = this.state;
    //console.log(issueCOList)
    let data = get(projectData, "data", null);
    const user = getLocalstorage("user");

    let isProjectAwardedByState =
      data && data.sponsoredByCategory === GROUP_KEYS.STATE;

    const createdBy =
      data && data.projectPPList && data.projectPPList.length
        ? data.projectPPList[0]
        : null;
    //

    return (
      <React.Fragment>
        <ConfirmationComponent
          show={showAlertMonthly}
          isLoading={false}
          modalClass={"confirmation-modal"}
          saveHandler={this.onSubmitMonthlyIssue}
          closeHandler={this.openConfirmationAlertMonthly}
          content={"Are you sure you want to submit?"}
          closeButton={false}
        />
        <Modal size="lg" show={showIssue} className="monthly-issue-modal">
          <div className="area-monthly-issue" />
          <Modal.Body style={{ overflow: "hidden" }}>
            <div className="modal-overlay">
              <span className="heading-issue-monthly">
                Open Issues Declaration
              </span>
              <p className="subline-issue-monthly">
                Please confirm if there are any Pending Issues in the project
              </p>
              <div className={`slider-monthly page-${page}`}>
                {/* {page == 1 && ( */}
                <div
                  className={`container-monthly page-modal page-1 ${
                    page == 2 ? "exit" : ""
                  }`}
                >
                  <div
                    className={`layout-radio radio-issue-monthly ${
                      noPendingIssue ? "active" : ""
                    }`}
                    onClick={() => this.handleCheckboxChange("noPendingIssue")}
                  >
                    <Image
                      src={noPendingIssue ? CheckRed : RadioUncheck}
                      className={`radio-size ${noPendingIssue ? "active" : ""}`}
                    />
                    <span
                      className={`monthly-issues ${
                        noPendingIssue ? "active" : ""
                      }`}
                    >
                      There are no pending issues
                    </span>
                  </div>

                  <div
                    className={`layout-radio radio-issue-monthly ${
                      pendingIssue ? "active" : ""
                    }`}
                    onClick={() => this.handleCheckboxChange("pendingIssue")}
                  >
                    <Image
                      src={pendingIssue ? CheckRed : RadioUncheck}
                      className={`radio-size ${pendingIssue ? "active" : ""}`}
                    />
                    <span
                      className={`monthly-issues ${
                        pendingIssue ? "active" : ""
                      } padding-issue`}
                    >
                      There are pending issues
                    </span>
                  </div>
                  {!(pendingIssue || noPendingIssue) ? (
                    <div className="display-none" />
                  ) : (
                    <div className="margin-submit-proceed">
                      {!noPendingIssue && !pendingIssue ? (
                        ""
                      ) : noPendingIssue ? (
                        <Button
                          variant="primary"
                          onClick={this.openConfirmationAlertMonthly}
                          className="submit-monthly-issue btn-orange"
                        >
                          Submit
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          className="button-enable-monthly btn-orange"
                          onClick={this.nextPage}
                        >
                          Proceed
                        </Button>
                      )}
                    </div>
                  )}
                </div>

                <div
                  className={`container-monthly page-modal page-2 ${
                    page == 1 ? "exit" : ""
                  }`}
                >
                  <div
                    className={`layout-radio layout-radio-monthly-pending radio-issue-monthly-pending ${
                      pendingIssueRaised ? "active" : ""
                    }`}
                    onClick={() =>
                      this.handleCheckboxChange("pendingIssueRaised")
                    }
                  >
                    <Image
                      src={pendingIssueRaised ? CheckBlue : RadioUncheck}
                      className={`radio-size-pending ${
                        pendingIssueRaised ? "active" : ""
                      }`}
                    />
                    <span
                      className={`monthly-issues-pending ${
                        pendingIssueRaised ? "active" : ""
                      }`}
                    >
                      All Issues already raised on the PMG Portal
                    </span>
                  </div>

                  <div
                    className={`layout-radio  layout-radio-not-raised radio-issue-monthly-pending ${
                      pendingIssueNotRaised ? "active" : ""
                    }`}
                    onClick={() =>
                      this.handleCheckboxChange("pendingIssueNotRaised")
                    }
                  >
                    <Image
                      src={pendingIssueNotRaised ? CheckBlue : RadioUncheck}
                      className={`radio-size-pending ${
                        pendingIssueNotRaised ? "active" : ""
                      }`}
                      style={{ marginLeft: 2 }}
                    />
                    <span
                      className={`monthly-issues-pending ${
                        pendingIssueNotRaised ? "active" : ""
                      }`}
                    >
                      Some Issues not yet raised on the PMG Portal
                    </span>
                  </div>
                  {!(pendingIssue || noPendingIssue) ? (
                    <div className="display-none" />
                  ) : (
                    <div className="submit-back">
                      <Button
                        variant="primary"
                        onClick={this.prevPage}
                        className="back-button btn-orange-invert no-padding issue-back-btn btn"
                      >
                        <span className="issue-back-icon" /> Back
                      </Button>
                      {pendingIssueNotRaised ? (
                        <Button
                          variant="primary"
                          className="button-enable-monthly btn-orange margin-left-15"
                          disabled={
                            pendingIssueRaised
                              ? false
                              : pendingIssueNotRaised
                              ? false
                              : true
                          }
                          onClick={this.proceedToAddIssue}
                          // onClick={this.openConfirmationAlertMonthly}
                        >
                          Proceed
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          className={
                            !pendingIssueRaised && !pendingIssueNotRaised
                              ? "submit-monthly-issue margin-left-15 submit-text-back submit-text"
                              : "submit-monthly-issue margin-left-15 btn-orange"
                          }
                          disabled={
                            pendingIssueRaised
                              ? false
                              : pendingIssueNotRaised
                              ? false
                              : true
                          }
                          onClick={this.openConfirmationAlertMonthly}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* <Modal show={this.state.showIssueNext} className="confirmation-modal">
          <div className="area-monthly-issue" />
          <Modal.Body>
            <div>
              <span className="confirm">Add New Issues</span>
              <p className="subline-issue-monthly">
                Please add issues in the project!
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              type="submit"
              className="button-enable-monthly btn-orange proceed-final"
              onClick={this.proceedToAddIssue}
            >
              Proceed
            </Button>
          </Modal.Footer>
        </Modal> */}

        {/* {this.state.showLanguageError === false && this.onMouseclick()} */}
        <LoaderPage loading={isApiLoading || isProposalValidated} />
        <div className="content no-sidebar">
          <ProjectDetailWithLoader
            handleOnClick={this.handleOnClick}
            toggle={true}
            isLoading={projectDetailsStatus}
            isProjectAwardedByState={isProjectAwardedByState}
            callApiOnSuccess={() => this.getIssueListData()}
          />
          {/* <ConfirmationComponent
            show={showAlert}
            isLoading={issueSubmitted}
            modalClass={"confirmation-modal"}
            saveHandler={this.state.showModal?this.onSubmit:this.onSubmitAddIssueForm}
            closeHandler={
              this.state.showModal
                ? this.prevPageforModel
                : this.closeModalonAddIsse
            }
          /> */}
          {showAlert ? (
            <ConfirmationComponent
              show={showAlert}
              isLoading={issueSubmitted}
              modalClass={"confirmation-modal"}
              saveHandler={this.onSubmitAddIssueForm}
              closeHandler={this.closeModalonAddIsse}
            />
          ) : null}
          {addIssueSubmitModal ? (
            <ConfirmationComponent
              show={addIssueSubmitModal}
              isLoading={isApiLoading}
              modalClass={"confirmation-modal"}
              saveHandler={this.onSubmit}
              closeHandler={this.handleClose}
            />
          ) : null}
          <div className="project-page-issues" ref={this.issueListContainer}>
            <div className="small-container">
              {issueListApiStatus === STATUS.LOADING ||
              isValidArray(get(issueListDTO, "listDTO")) ? (
                <div
                  className="more-issue-wrapper"
                  ref={elem => {
                    this.issueListElement = elem;
                  }}
                >
                  <h2>
                    {get(issueListDTO, "total", 0)} issues in this project
                  </h2>
                  <IssueListWitLoader
                    issueList={get(issueListDTO, "listDTO")}
                    isLoading={issueListApiStatus}
                    permission={permission}
                    callApiOnSuccess={() => {
                      this.initialApiCall();
                      this.getIssueListData({ offset });
                    }}
                  />
                  <Pagination
                    offset={offset}
                    onPageChange={this.onPageChange}
                    pageCount={
                      get(issueListDTO, "total", 0) /
                      get(issueListDTO, "limit", 0)
                    }
                  />
                </div>
              ) : null}
              {this.state.showModal ? (
                <Modal
                  size="lg"
                  show={true}
                  onHide={this.onShow}
                  className="edit-issue"
                  backdrop="static" // ⬅️ Prevents close on outside click
                  keyboard={false}
                >
                  <Modal.Header />
                  <Modal.Body className="edit-issue-model">
                    <div className="create-issue-wrapper-edit">
                      {!get(permission, "canViewOnlyIssues") &&
                      get(data, "addMoreIssue") &&
                      get(data, "allowAddIssue") ? (
                        <div className="edit-issue-form  undefined first-issue">
                          {otherOption ? (
                            <AddIssue
                              showLanguageError={this.state.showLanguageError}
                              handleProposalChange={this.handleProposalChange}
                              title="Add Issue"
                              issueSaved={issueSaved}
                              params={{
                                show: get(data, "displayAutocomplete"),
                                allowOnCreate: get(data, "allowOnCreate"),
                                resetForm: resetForm,
                                error: error.issuesError,
                                showModal: this.state.showModal,
                                //isEdit: true,
                                errorCOListError: error.issueCOListError,
                                initialRequiredFields: initialRequiredFields,
                                updateParentState: this.updateParentState,
                                updateParentStateError: this
                                  .updateParentStateError,
                                prevPage: this.prevPageforModel,
                                resetIssue: this.resetAddIssue,
                                addIssueErrorUpdate: this.addIssueErrorUpdate,
                                isProjectAwardedByState: isProjectAwardedByState,
                                parentGroupId: data && data.sponsoredByid,
                                selectedOptionImageUrl:
                                  data && data.sponsoredByImageUrl,
                                workflowType: data && data.workflowType,
                                projectPPList: data && data.projectPPList,
                                createdBy: _createdBy,
                                projectID: get(projectData, "data.id", null)
                              }}
                              onValidateForm={this.onValidateForm}
                              onRemoveFileDetail={this.onRemoveFile}
                            />
                          ) : (
                            <AddIssue
                              showLanguageError={this.state.showLanguageError}
                              handleProposalChange={this.handleProposalChange}
                              title="Add Issue"
                              issueSaved={issueSaved}
                              params={{
                                show: get(data, "displayAutocomplete"),
                                allowOnCreate: get(data, "allowOnCreate"),
                                resetForm: resetForm,
                                error: error.issuesError,
                                showModal: this.state.showModal,
                                //isEdit: true,
                                errorCOListError: error.issueCOListError,
                                initialRequiredFields: initialRequiredFields,
                                updateParentState: this.updateParentState,
                                updateParentStateError: this
                                  .updateParentStateError,
                                prevPage: this.prevPageforModel,
                                resetIssue: this.resetAddIssue,
                                addIssueErrorUpdate: this.addIssueErrorUpdate,
                                isProjectAwardedByState: isProjectAwardedByState,
                                parentGroupId: data && data.sponsoredByid,
                                selectedOptionImageUrl:
                                  data && data.sponsoredByImageUrl,
                                workflowType: data && data.workflowType,
                                projectPPList: data && data.projectPPList,
                                createdBy: _createdBy,
                                projectID: get(projectData, "data.id", null)
                              }}
                              onValidateForm={this.onValidateForm}
                              onRemoveFileDetail={this.onRemoveFile}
                              issueCOListData={this.state.issueCOList}
                              backButtonPress={this.state.backButtonPress}
                              ministryList={this.state.ministryList}
                              STATE={this.state.STATE}
                              districtList={this.state.districtList}
                              subCategoryList={this.state.subCategoryList}
                              milestoneLists={this.state.milestoneLists}
                              milestoneTables={this.state.milestoneTables}
                              CENTRAL={CENTRAL}
                              DISTRICT={DISTRICT}
                              STATE_DEPARTMENT={STATE_DEPARTMENT}
                              CENTRAL_DEPARTMENT={CENTRAL_DEPARTMENT}
                              OTHER={OTHER}
                              INDUSTRIAL={INDUSTRIAL}
                              //otherOption={otherOption}
                            />
                          )}
                        </div>
                      ) : null}
                    </div>
                  </Modal.Body>
                </Modal>
              ) : (
                <div className="add-more-issue-wrapper" ref={this.myDivToFocus}>
                  {!get(permission, "canViewOnlyIssues") &&
                  get(data, "addMoreIssue") &&
                  get(data, "allowAddIssue") ? (
                    <>
                      <AddIssue
                        showLanguageError={this.state.showLanguageError}
                        handleProposalChange={this.handleProposalChange}
                        title="Add Issue"
                        issueSaved={issueSaved}
                        params={{
                          show: get(data, "displayAutocomplete"),
                          allowOnCreate: get(data, "allowOnCreate"),
                          resetForm: resetForm,
                          error: error.issuesError,
                          errorCOListError: error.issueCOListError,
                          initialRequiredFields: initialRequiredFields,
                          updateParentState: this.updateParentState,
                          updateParentStateError: this.updateParentStateError,
                          resetIssue: this.resetAddIssue,
                          addIssueErrorUpdate: this.addIssueErrorUpdate,
                          isProjectAwardedByState: isProjectAwardedByState,
                          parentGroupId: data && data.sponsoredByid,
                          selectedOptionImageUrl:
                            data && data.sponsoredByImageUrl,
                          workflowType: data && data.workflowType,
                          projectPPList: data && data.projectPPList,
                          createdBy: _createdBy,
                          projectID: get(projectData, "data.id", null)
                        }}
                        onValidateForm={this.onValidateForm}
                        onRemoveFileDetail={this.onRemoveFile}
                      />
                    </>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
        <div />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueList: state.commonReducer.issueList,
    projectData: state.projectDetailsReducer.projectData,
    issueListStatus: state.commonReducer.issueListStatus,
    projectDetailsStatus: state.projectDetailsReducer.projectDetailsStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getIssueList: getIssueList,
      createIssueDispatch: createIssueAction,
      clearIssueListDispatch: clearIssueList,
      getProjectDetails,
      fetchAllProjectStatus,
      declareMonthlyIssueDispatch: declareMonthlyIssueAction
    },
    dispatch
  );
}

export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Details)
  )
);
